import { Base64 } from 'js-base64'
import store from './store'

const server = process.env.NODE_ENV === 'development'
  ? 'http://flossy.local:8001'
  : `https://${process.env.VUE_APP_STAGE === 'dev' ? 'dev.' : ''}api.timesheets.mavis.machineshop.co.uk`

export function createURL(endpoint, params) {
  let query = ''
  if (params) {
    const usp = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
      const values = Array.isArray(value) ? value : [value]
      values.forEach((v) => {
        usp.append(key, v)
      })
    }
    query = usp.toString()
  }

  if (endpoint[0] !== '/') {
    endpoint = `/${endpoint}`
  }

  return `${server}${endpoint}?${query}`
}

async function fetchEndpoint(method, endpoint, params, json = false) {
  const url = createURL(endpoint, json ? null : params)
  const headers = new Headers()
  const auth = Base64.encode(store.getters.credentials.join(':'))
  headers.set('Authorization', `Basic ${auth}`)
  const body = json ? (headers.set('Content-Type', 'application/json'), JSON.stringify(params)) : undefined

  try {
    const response = await fetch(url, { method, headers, body })
    const text = await response.text()
    const data = text ? JSON.parse(text) : null
    if (!response.ok) throw data
    return data ?? true
  } catch (e) {
    if (e && e.detail !== undefined) throw e
    store.commit('serverConnectionLost')
  }
  return null
}

export function get(endpoint, params) {
  return fetchEndpoint('GET', endpoint, params)
}

export function post(endpoint, params) {
  return fetchEndpoint('POST', endpoint, params)
}

export function put(endpoint, params) {
  return fetchEndpoint('PUT', endpoint, params)
}

export function putJson(endpoint, data) {
  return fetchEndpoint('PUT', endpoint, data, true)
}

export function del(endpoint, params) {
  return fetchEndpoint('DELETE', endpoint, params)
}

export async function postFile(endpoint, folder, file) {
  const url = createURL(endpoint, { folder })
  const headers = new Headers()
  const auth = Base64.encode(store.getters.credentials.join(':'))
  headers.set('Authorization', `Basic ${auth}`)
  const body = new FormData()
  body.append('file', file)
  try {
    const response = await fetch(url, { method: 'POST', headers, body })
    const text = await response.text()
    const data = text ? JSON.parse(text) : null
    if (!response.ok) throw data
    return data ?? true
  } catch (e) {
    if (e && e.detail !== undefined) throw e
    store.commit('serverConnectionLost')
  }
  return null
}
